export default __webpack_public_path__ + "static/media/studying-competitive-landscape.312ed3ee.svg";